import React from 'react';
import { ChevronUp, ChevronDown, Trash2, Plus } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { DependsOnPicker } from './DependsOnPicker';

const newKey = () => Math.random().toString(36).slice(2, 10);
const move = (arr, i, d) => {
  const j = i + d;
  if (j < 0 || j >= arr.length) return arr;
  const a = [...arr];
  [a[i], a[j]] = [a[j], a[i]];
  return a;
};
const IconBtn = ({ onClick, children, testId, danger }) => (
  <button type="button" onClick={onClick} data-testid={testId}
    className={`p-1 rounded text-stone-400 ${danger ? 'hover:text-red-700 hover:bg-red-50' : 'hover:text-stone-900 hover:bg-stone-100'}`}>{children}</button>
);

export const TemplateStageEditor = ({ stage, si, total, allOptions, onChange, onMove, onDelete }) => {
  const setTasks = (tasks) => onChange({ ...stage, tasks });
  const setTask = (ti, patch) => setTasks(stage.tasks.map((t, i) => i === ti ? { ...t, ...patch } : t));

  return (
    <section className="bg-white border border-stone-200 rounded-lg overflow-hidden" data-testid={`tmpl-stage-${si}`}>
      <header className="flex items-center gap-2 px-4 py-3 bg-stone-50 border-b border-stone-200">
        <span className="w-6 h-6 shrink-0 rounded-full bg-stone-900 text-white text-[11px] font-semibold flex items-center justify-center">{si + 1}</span>
        <Input value={stage.name} onChange={e => onChange({ ...stage, name: e.target.value })} data-testid={`tmpl-stage-name-${si}`}
          className="h-8 font-semibold text-sm border-transparent bg-transparent hover:border-stone-200 focus:bg-white" />
        <IconBtn onClick={() => onMove(-1)} testId={`tmpl-stage-up-${si}`}><ChevronUp className="w-4 h-4" /></IconBtn>
        <IconBtn onClick={() => onMove(1)} testId={`tmpl-stage-down-${si}`}><ChevronDown className="w-4 h-4" /></IconBtn>
        <IconBtn onClick={onDelete} testId={`tmpl-stage-delete-${si}`} danger><Trash2 className="w-4 h-4" /></IconBtn>
      </header>
      {stage.tasks.map((t, ti) => (
        <div key={t.key} className="flex flex-wrap md:flex-nowrap items-center gap-2 px-4 py-2 border-b border-stone-100" data-testid={`tmpl-task-${si}-${ti}`}>
          <Input value={t.title} onChange={e => setTask(ti, { title: e.target.value })} data-testid={`tmpl-task-title-${si}-${ti}`}
            className="h-8 text-sm flex-1 min-w-[200px]" placeholder="Task name" />
          <DependsOnPicker options={allOptions.filter(o => o.id !== t.key)} value={t.depends_on || []}
            onChange={v => setTask(ti, { depends_on: v })} testId={`tmpl-task-deps-${si}-${ti}`} />
          <IconBtn onClick={() => setTasks(move(stage.tasks, ti, -1))} testId={`tmpl-task-up-${si}-${ti}`}><ChevronUp className="w-4 h-4" /></IconBtn>
          <IconBtn onClick={() => setTasks(move(stage.tasks, ti, 1))} testId={`tmpl-task-down-${si}-${ti}`}><ChevronDown className="w-4 h-4" /></IconBtn>
          <IconBtn onClick={() => setTasks(stage.tasks.filter((_, i) => i !== ti))} testId={`tmpl-task-delete-${si}-${ti}`} danger><Trash2 className="w-4 h-4" /></IconBtn>
        </div>
      ))}
      <button type="button" onClick={() => setTasks([...stage.tasks, { key: newKey(), title: '', description: '', depends_on: [] }])}
        data-testid={`tmpl-add-task-${si}`} className="w-full text-left px-4 py-2.5 text-xs text-amber-800 hover:bg-amber-50/50 inline-flex items-center gap-1">
        <Plus className="w-3.5 h-3.5" /> Add task
      </button>
    </section>
  );
};

export { newKey, move };
